const styleScreen = {
  rowContainer: {
    alignItems: "center",
    alignContent: "center",
    width: "auto",
  },
};
export { styleScreen };
